import React from 'react';
import axios from 'axios';

import { formatDateTime } from '../../../Utils/GlobalUtils';

import { useModal } from '../../Modal/ModalContext';
import { useTimeModal } from '../../TimeModal/TimeModalContext';

import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';
import ViewFileById from '../../ViewFileById';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const ListMailing = ({ caseId, closeModal, openAttachAM, onSuccess }) => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();

    const [cases, setCases] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);
    const [warning, setWarning] = React.useState('');

    React.useEffect(() => {
        setLoading(true);

        axios.get(`/api/get-case-applications?case_id=${caseId}`)
            .then((response) => {
                setWarning('');
                setCases(response.data.applications || []);
            })
            .catch((error) => {
                console.error(error);
                setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            })
            .finally(() => {
                setReload(false);
                setLoading(false);
            });
    }, [reload, caseId]);

    const [expandedRegions, setExpandedRegions] = React.useState([]);

    const toggleRegion = (regionName) => {
        setExpandedRegions((prev) =>
            prev.includes(regionName)
                ? prev.filter((name) => name !== regionName)
                : [...prev, regionName]
        );
    };


    const pendingCases = cases.filter(
        (item) => item.mailing_status === 'Письмо не отправлено'
    );

    const firstCases = cases.filter(
        (item) => item.status === 'Ранее откреплен' || item.status === 'Согласие направлено' || item.status === 'Выбран СРО'
    );

    const groupedByRegion = React.useMemo(() => {
        return cases.reduce((acc, item) => {
            const region = item?.region_name || 'Регион не указан';

            if (!acc[region]) {
                acc[region] = [];
            }

            acc[region].push(item);

            return acc;
        }, {});
    }, [cases]);


    const attachAMForCase = (caseId, userId, applicationId) => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.put('/api/attach-am-for-case', {
            case_id: caseId,
            user_id: userId,
            application_id: applicationId
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            openTimeModal('Арбитражный управляющий успешно прикреплен к карточке', 'success');
            closeModal();
            onSuccess();
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось прикрепить арбитражного управляющего к карточке. Попробуйте повторить позднее`, 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const tryAgainSendOffers = (caseId) => {
        setLoading(true);
        axios.post('/api/try-again-send-offers', {
            caseId: caseId
        })
        .then((response) => {
            setReload(true);
            openTimeModal(`Предложения на ведение дела успешно отправлены`, 'success');
        })
        .catch((error) => {
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    };
    
    const tryAgainSendOffer = (caseId, email) => {
        setLoading(true);
        axios.post('/api/try-again-send-offer', {
            caseId: caseId,
            email: email
        })
        .then((response) => {
            setReload(true);
            openTimeModal(`Предложение на ведение дела успешно отправлено`, 'success');
        })
        .catch((error) => {
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    };

    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Статус рассылки опроса</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size="20" color="black" />
                </div>
                <div className={styles.main} style={{ minHeight: '500px' }}>
                    {loading ? <div>Загрузка... Не закрывайте это окно<Loading /></div>
                    : warning ? <WarningPanel text={warning} buttonText='Обновить' buttonAction={() => setReload(true)} />
                    :
                        <>
                            {firstCases.length > 0 ? (
                                <div className='listWrapper'>
                                    <h3>
                                        Некоторые управляющие прислали документы
                                    </h3>
                                    {firstCases.map((application) => (
                                        <div className={styles.wideMailingLine} key={application.id} style={application.user?.approval=='Отключен' ? {boxShadow: '0 0 0 1px red', backgroundColor: 'rgb(255, 222, 222)'} : {}}>
                                            <span className={styles.amInfoAction}>
                                                <span className={styles.amInfo}>
                                                    {application.user && <p>{application.user?.lastname} {application.user?.firstname} {application.user?.surname}</p>}
                                                    {application.user?.approval=='Отключен' ?
                                                        <p>Аккаунт управляющего деактивирован</p>
                                                    : application.user?.approval=='На рассмотрении' ?
                                                        <p>Аккаунт управляющего на проверке после регистрации</p>
                                                    : !application.user?.approval &&
                                                        <p>Не зарегистрирован в ЛК</p>
                                                    }
                                                    <a href={`mailto:${application.email}`} className={styles.aWithLink}>{application.email}</a>
                                                    <div
                                                        style={{display: 'flex', flexDirection: 'column', maxWidth: '330px'}}
                                                    >
                                                        <span
                                                            className='horizontalContainer'
                                                        >
                                                            {application.user && <a className={`${application.user?.balance<0 && 'colorCell red'}`}>{application.user?.balance + ' ₽'}</a>}
                                                            <p className='description'>Членские взносы</p>
                                                        </span>
                                                        <span className='horizontalLine'></span>
                                                        <span
                                                            className='horizontalContainer'
                                                        >
                                                            {application.user && <a className={`${application.user?.special_balance<0 && 'colorCell red'}`}>{application.user?.special_balance + ' ₽'}</a>}
                                                            <p className='description'>Целевые взносы</p>
                                                        </span>
                                                    </div>
                                                    <div
                                                        className={styles.timeline}
                                                    >
                                                    {application.files.map((file, index) => (
                                                        <div
                                                            key={index}
                                                            className={styles.timelineItem}
                                                        >
                                                            <div
                                                            >
                                                                <p>
                                                                {file.type=='appointmentAMAgreement' && 'Согласие на назначение'}
                                                                {file.type=='appointmentAMRefusal' && 'Отзыв согласия на назначение'}
                                                                </p>
                                                                <p className='description'>{formatDateTime(file.created_at)}</p>
                                                            </div>
                                                            <ViewFileById fileId={file.file_id} />
                                                        </div>
                                                    ))}
                                                    </div>
                                                </span>
                                                <span className={styles.amBtn}>
                                                    {application.status=='Выбран СРО' ?
                                                        <p className='description'>Сейчас выбран СРО</p>
                                                    :
                                                        <button 
                                                            type='button' 
                                                            className='miniButton' 
                                                            onClick={() => {attachAMForCase(application.case_id, application.user.id, application.id)}}
                                                        >
                                                            Выбрать
                                                        </button>
                                                    }
                                                </span>
                                            </span>
                                            {application.mailing_status=='Письмо не отправлено' ?
                                                <div className={`${styles.applicationStatus} ${styles.red}`}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-octagon"><path fill="currentColor" d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Zm0,8a1,1,0,1,0,1,1A1,1,0,0,0,12,15Zm9.71-7.44L16.44,2.29A1.05,1.05,0,0,0,15.73,2H8.27a1.05,1.05,0,0,0-.71.29L2.29,7.56A1.05,1.05,0,0,0,2,8.27v7.46a1.05,1.05,0,0,0,.29.71l5.27,5.27a1.05,1.05,0,0,0,.71.29h7.46a1.05,1.05,0,0,0,.71-.29l5.27-5.27a1.05,1.05,0,0,0,.29-.71V8.27A1.05,1.05,0,0,0,21.71,7.56ZM20,15.31,15.31,20H8.69L4,15.31V8.69L8.69,4h6.62L20,8.69Z"></path></svg>
                                                    Не удалось отправить письмо при рассылке, но управляющий прислал согласие из личного кабинета
                                                </div>
                                            : application.status == 'Претендует' ? 
                                                <a className={styles.applicationStatus}>
                                                    <svg style={{height: '20px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="currentColor" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
                                                    {application.status}
                                                </a>
                                            : application.status == 'Ранее откреплен' && 
                                                <a className={styles.applicationStatus}>
                                                    <svg id="clock" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path></svg>
                                                    {application.status}
                                                </a>
                                            }
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className='listWrapper'>
                                    <h3>
                                        Сводка
                                    </h3>
                                    <p style={{fontSize: '14px'}}>Пока что ни один управляющий не прислал согласие на ведение дела</p>
                                </div>
                            )}


                            {pendingCases.length > 0 && (
                                <>
                                <div className='listWrapper'>
                                    <h3 className='horizontalHeadline'>
                                        Некоторым управляющим не дошло письмо рассылки опроса
                                        <button 
                                            type='button' 
                                            className='tableButton blue'
                                            onClick={() => {tryAgainSendOffers(caseId)}}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="redo"><path fill="currentColor" d="M21,11a1,1,0,0,0-1,1,8.05,8.05,0,1,1-2.22-5.5h-2.4a1,1,0,0,0,0,2h4.53a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4.77A10,10,0,1,0,22,12,1,1,0,0,0,21,11Z"></path></svg>
                                            Доотправить письма
                                        </button>
                                    </h3>
                                    <p className='description'>Управляющие из данного списка получили предложение в личном кабинете, несмотря на то, что email-уведомление не было доставлено</p>
                                    {pendingCases.map((application) => (
                                        <div className={styles.wideMailingLine} key={application.id} style={application.user?.approval=='Отключен' ? {boxShadow: '0 0 0 1px red', backgroundColor: 'rgb(255, 222, 222)'} : {}}>
                                            <span className={styles.amInfoAction}>
                                                <span className={styles.amInfo}>
                                                    {application.user && <p>{application.user?.lastname} {application.user?.firstname} {application.user?.surname}</p>}
                                                    {application.user?.approval=='Отключен' ?
                                                        <p>Аккаунт управляющего деактивирован</p>
                                                    : application.user?.approval=='На рассмотрении' ?
                                                        <p>Аккаунт управляющего на проверке после регистрации</p>
                                                    : !application.user?.approval &&
                                                        <p>Не зарегистрирован в ЛК</p>
                                                    }
                                                    <a href={`mailto:${application.email}`} className={styles.aWithLink}>{application.email}</a>
                                                    <span
                                                        className='horizontalContainer'
                                                    >
                                                        {application.user && <a className={`${application.user?.balance<0 && 'colorCell red'}`}>{application.user?.balance + ' ₽'}</a>}
                                                        <p className='description'>Членские взносы</p>
                                                    </span>
                                                    <span className='horizontalLine'></span>
                                                    <span
                                                        className='horizontalContainer'
                                                    >
                                                        {application.user && <a className={`${application.user?.special_balance<0 && 'colorCell red'}`}>{application.user?.special_balance + ' ₽'}</a>}
                                                        <p className='description'>Целевые взносы</p>
                                                    </span>
                                                    <div
                                                        className={styles.timeline}
                                                    >
                                                    {application.files.map((file, index) => (
                                                        <div
                                                            key={index}
                                                            className={styles.timelineItem}
                                                        >
                                                            <div
                                                            >
                                                                <p>
                                                                {file.type=='appointmentAMAgreement' && 'Согласие на назначение'}
                                                                {file.type=='appointmentAMRefusal' && 'Отзыв согласия на назначение'}
                                                                </p>
                                                                <p className='description'>{formatDateTime(file.created_at)}</p>
                                                            </div>
                                                            <ViewFileById fileId={file.file_id} />
                                                        </div>
                                                    ))}
                                                    </div>
                                                </span>
                                                <span className={styles.amBtn}>
                                                    {application.mailing_status=='Письмо не отправлено' && <button type='button' className='miniButton' onClick={() => {tryAgainSendOffer(application.case_id, application.email)}}>Отправить письмо</button>}
                                                    {(application.user && application.status!=='Выбран СРО') ?
                                                        <button 
                                                            type='button' 
                                                            className='miniButton' 
                                                            onClick={() => {attachAMForCase(application.case_id, application.user.id, application.id)}}
                                                        >
                                                            Выбрать
                                                        </button>
                                                    : 
                                                        <button 
                                                            type='button' 
                                                            className='miniButton' 
                                                            onClick={() => {openTimeModal('Управляющий не зарегистрирован в ЛК', 'warning')}}
                                                            disabled={true}
                                                        >
                                                            Выбрать
                                                        </button>
                                                    }
                                                </span>
                                            </span>
                                            {application.mailing_status=='Письмо не отправлено' ?
                                                <div className={`${styles.applicationStatus} ${styles.red}`}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-octagon"><path fill="currentColor" d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Zm0,8a1,1,0,1,0,1,1A1,1,0,0,0,12,15Zm9.71-7.44L16.44,2.29A1.05,1.05,0,0,0,15.73,2H8.27a1.05,1.05,0,0,0-.71.29L2.29,7.56A1.05,1.05,0,0,0,2,8.27v7.46a1.05,1.05,0,0,0,.29.71l5.27,5.27a1.05,1.05,0,0,0,.71.29h7.46a1.05,1.05,0,0,0,.71-.29l5.27-5.27a1.05,1.05,0,0,0,.29-.71V8.27A1.05,1.05,0,0,0,21.71,7.56ZM20,15.31,15.31,20H8.69L4,15.31V8.69L8.69,4h6.62L20,8.69Z"></path></svg>
                                                    Не удалось отправить письмо при рассылке
                                                </div>
                                            : application.status == 'Претендует' ? 
                                                <a className={styles.applicationStatus}>
                                                    <svg style={{height: '20px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="currentColor" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
                                                    {application.status}
                                                </a>
                                            : application.status == 'Ранее откреплен' && 
                                                <a className={styles.applicationStatus}>
                                                    <svg id="clock" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path></svg>
                                                    {application.status}
                                                </a>
                                            }
                                        </div>
                                    ))}
                                </div>
                                <div style={{ height: '20px' }}></div>
                                </>
                            )}

                            
                            <div className='listWrapper'>
                                <h3>Все записи рассылки</h3>
                                {cases.length===0 && <>
                                    <p className='description'>Записей рассылки не найдено. Возможно, они были удалены из системы по запросу</p>
                                </>}
                                {Object.entries(groupedByRegion).map(([regionName, regionCases]) => (
                                    <div key={regionName} className={styles.dropdownList}>

                                            <div
                                                className={styles.headForDdList}
                                                onClick={() => toggleRegion(regionName)} 
                                            >
                                                <a>{regionName}</a>
                                                <div className='actions'>
                                                    {expandedRegions.includes(regionName) ? (
                                                        <svg xmlns="http://www.w3.org/2000/svg" id="Isolation_Mode" data-name="Isolation Mode" viewBox="0 0 24 24"><path d="M0,16.019,9.52,6.513a3.507,3.507,0,0,1,4.948,0L24,16.031l-2.121,2.117L12.348,8.63a.5.5,0,0,0-.707,0l-9.52,9.507Z"/></svg>
                                                    ) : (
                                                        <svg xmlns="http://www.w3.org/2000/svg" data-name="Isolation Mode" viewBox="0 0 24 24"><path d="M0,8.057l9.52,9.507a3.507,3.507,0,0,0,4.948,0L24,8.046,21.879,5.929l-9.531,9.517a.5.5,0,0,1-.707,0L2.121,5.94Z"/></svg>
                                                    )}
                                                </div>
                                            </div>

                                            {expandedRegions.includes(regionName) && (
                                                <div className={styles.expandedPartOfTheList}>
                                                    {regionCases.map((application) => (
                                                    <div 
                                                        className={styles.wideMailingLine} 
                                                        key={application.id} 
                                                        style={application.user?.approval=='Отключен' ? {boxShadow: '0 0 0 1px red', backgroundColor: 'rgb(255, 222, 222)'} : {}}
                                                    >
                                                        <span className={styles.amInfoAction}>
                                                            <span className={styles.amInfo}>
                                                                {application.user && <p>{application.user?.lastname} {application.user?.firstname} {application.user?.surname}</p>}
                                                                {application.user?.approval=='Отключен' ?
                                                                    <p className='description'>Аккаунт управляющего деактивирован</p>
                                                                : application.user?.approval=='На рассмотрении' ?
                                                                    <p className='description'>Аккаунт управляющего на проверке после регистрации</p>
                                                                : !application.user?.approval &&
                                                                    <p className='description'>Не зарегистрирован в ЛК</p>
                                                                }
                                                                <a href={`mailto:${application.email}`} className={styles.aWithLink}>{application.email}</a>
                                                                <span
                                                                    className='horizontalContainer'
                                                                >
                                                                    {application.user && <a className={`${application.user?.balance<0 && 'colorCell red'}`}>{application.user?.balance + ' ₽'}</a>}
                                                                    <p className='description'>Членские взносы</p>
                                                                </span>
                                                                <span className='horizontalLine'></span>
                                                                <span
                                                                    className='horizontalContainer'
                                                                >
                                                                    {application.user && <a className={`${application.user?.special_balance<0 && 'colorCell red'}`}>{application.user?.special_balance + ' ₽'}</a>}
                                                                    <p className='description'>Целевые взносы</p>
                                                                </span>
                                                                <div
                                                                    className={styles.timeline}
                                                                >
                                                                {application.files.map((file, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className={styles.timelineItem}
                                                                    >
                                                                        <div
                                                                        >
                                                                            <p>
                                                                            {file.type=='appointmentAMAgreement' && 'Согласие на назначение'}
                                                                            {file.type=='appointmentAMRefusal' && 'Отзыв согласия на назначение'}
                                                                            </p>
                                                                            <p className='description'>{formatDateTime(file.created_at)}</p>
                                                                        </div>
                                                                        <ViewFileById fileId={file.file_id} />
                                                                    </div>
                                                                ))}
                                                                </div>
                                                            </span>
                                                            <span className={styles.amBtn}>
                                                                {application.mailing_status=='Письмо не отправлено' && <button type='button' className='miniButton' onClick={() => {tryAgainSendOffer(application.case_id, application.email)}}>Отправить письмо</button>}
                                                                {(application.user && application.status!=='Выбран СРО') ?
                                                                    <button 
                                                                        type='button' 
                                                                        className='miniButton' 
                                                                        onClick={() => {attachAMForCase(application.case_id, application.user.id, application.id)}}
                                                                    >
                                                                        Выбрать
                                                                    </button>
                                                                : 
                                                                    <button 
                                                                        type='button' 
                                                                        className='miniButton' 
                                                                        onClick={() => {openTimeModal('Управляющий не зарегистрирован в ЛК', 'warning')}}
                                                                        disabled={true}
                                                                    >
                                                                        Выбрать
                                                                    </button>
                                                                }
                                                            </span>
                                                        </span>
                                                        <p className={`${styles.applicationStatus} ${application.mailing_status == 'Письмо не отправлено' && styles.red}`}>
                                                            {application.mailing_status == 'Письмо не отправлено' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-octagon"><path fill="currentColor" d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Zm0,8a1,1,0,1,0,1,1A1,1,0,0,0,12,15Zm9.71-7.44L16.44,2.29A1.05,1.05,0,0,0,15.73,2H8.27a1.05,1.05,0,0,0-.71.29L2.29,7.56A1.05,1.05,0,0,0,2,8.27v7.46a1.05,1.05,0,0,0,.29.71l5.27,5.27a1.05,1.05,0,0,0,.71.29h7.46a1.05,1.05,0,0,0,.71-.29l5.27-5.27a1.05,1.05,0,0,0,.29-.71V8.27A1.05,1.05,0,0,0,21.71,7.56ZM20,15.31,15.31,20H8.69L4,15.31V8.69L8.69,4h6.62L20,8.69Z"></path></svg>}
                                                            {application.status == 'Согласие направлено' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="currentColor" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>}
                                                            {application.status == 'Ранее откреплен' && <svg id="clock" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path></svg>}
                                                            {application.mailing_status == 'Письмо не отправлено' ? application.mailing_status : application.status}
                                                        </p>
                                                    </div>))}
                                                </div>
                                            )}
                                    </div>
                                ))}
                            </div>
                            <div className='listWrapper'>
                                <h3>Другие варианты</h3>
                                <button type='button' className='miniButton' onClick={() => {openAttachAM('withMailing')}}>Доотправить письма другим арбитражным управляющим</button>
                                <button type='button' className='miniButton' onClick={() => {openAttachAM('withoutMailing')}}>Выбрать управляющего из общего списка</button>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    );
};

export default ListMailing;
